export interface AmbientSound {
  id: string
  name: string
  description: string
  icon: string
  file: string
}

export const AMBIENT_SOUNDS: AmbientSound[] = [
  {
    id: 'river',
    name: '小河流水',
    description: '潺潺流水，宁静惬意',
    icon: '💧',
    file: 'atmosphere-of-a-small-river-water-splash.mp3',
  },
  {
    id: 'forest',
    name: '森林瀑布',
    description: '鸟鸣声声，瀑布潺潺',
    icon: '🌲',
    file: 'birds-chirping-waterfall-in-the-background-forest-atmosphere.mp3',
  },
  {
    id: 'gentle',
    name: '静谧水流',
    description: '缓慢流淌，舒缓放松',
    icon: '🌊',
    file: 'water-slowly-flows-out-of-the-hose.mp3',
  },
]

export const AMBIENT_NONE = {
  id: 'none',
  name: '静音',
  description: '不播放环境音效',
  icon: '🔇',
}

export type AmbientSoundId = 'none' | 'river' | 'forest' | 'gentle'
